export interface IProblem {
    productId: string;
    customerId: string;
    motiveId: string;
    contactWrittenId: string;
    contactCallId: string;
}

export interface IProblemIssue {
    id: string;
    customerId: string;
    code: string;
    continue: true;
    type: string;
    phase: string;
    endedAt: string;
    createdAt: string;
    situation: string;
    motive: IProblemMotive;
    events: IProblemEvent[];
    product: IIndexGeneric;
    troubleTicket: IIndexGeneric;
    workOrders: IIndexGeneric[];
    shippingOrders: IIndexGeneric[];
    interactionRoles: IProblemInteractionRole[];
}
export interface IIndexGeneric {
    id: string;
}

export type IProblemWorkTask = {
    id: string;
    creationDate: string;
    statusWork: string;
    appointmentTask: {
        id: string;
        code: string;
        status: string;
        changeReason: string;
    };
    typeCause: string;
    type: string;
    details: string;
    anomalyCause: string;
    anomalySubCause: string;
};

export type IProblemShippingOrderTask = {
    id: string;

    creationDate: string;
    comments: string;
    type: string;
    typeName: string;
    incidentId: string;
    legacyIntermediateState: string;
    notificationId: string;
    errorId: string;
    itemTask: {
        creationDate: string;
        comments: string;
        type: string;
        typeName: string;
        status: string;
        incidentId: string;
        legacyIntermediateState: string;
        errorId: string;
        formattedDescription: string;
    };
    itemId: string;
    formattedDescription: string;
};

export type IProblemTroubleTicket = {
    id: string;
    code: string;
    detectionDate: string;
    restorationDate: string;
    targetDate: string;
    status: string;
    serviceProblem: {
        id: string;
        state: string;
        resourceTroubles: [];
    };
    location: string;
    incidents: [];
    provisioningOrders: [];
    workOrders: IIndexGeneric[];
    shippingOrders: IIndexGeneric[];
};

export type IProblemTroubleTicketTask = {
    id: string;
    date: string;
    description: string;
    type: string;
    plan: {
        id: string;
        name: string;
        assessment: string;
    };
    reason: string;
    responsibleType: string;
};

export interface IProblemInteractionRole {
    id: string;
    customerId: string;
    customerContactId: string;
    type: string;
}

export interface IProblemHistoricMessage {
    answer: string;
    question: string;
}

export interface IProblemDiagnosis {
    id: string;
    type: string;
    problemId?: string;
    motive: IProblemMotive;
    products: { productPsId: string; number: string }[];
}

export interface IProblemContact {
    id: string;
    type: string;
    value: string | number;
    favourite: string | boolean;
}

export interface IProblemCategory {
    id: string;
    name: string;
    description: string;
    motive: IProblemMotive;
    product: IIndexGeneric[];
}

export interface IProblemMotive {
    id: string;
    description: string;
    treeMotives: boolean;
}

export interface IProblemEvent {
    id: string;
    type: EProblemTypeEvent;
    problemId: string;
    dialogId: string;
    responseId: null;
    description: string;
    createdAt: string;
}

export interface IProblemQuestion {
    id: string;
    name: string;
    timeout?: number;
    next?: boolean;
    question: string;
    response?: IProblemResponse;
    responses: IProblemResponse[];
}

export interface IProblemResponse {
    id: string;
    text: string;
    open: boolean;
    validForStart: string;
}

export enum EProblemTypeEvent {
    TEST = 'TEST',
    ERROR = 'ERROR',
    QUESTION = 'QUESTION',
    ANSWER = 'ANSWER',
    DIAGNOSIS_ENDED = 'DIAGNOSIS_ENDED',
    DIAGNOSIS_RESUMED = 'DIAGNOSIS_RESUMED',
    DIAGNOSIS_ENDED_CANCELED = 'DIAGNOSIS_ENDED_CANCELED',
    DIAGNOSIS_ENDED_TESTING_PENDING = 'DIAGNOSIS_ENDED_TESTING_PENDING',
    DIAGNOSIS_ENDED_TRANSFER_CHANNEL = 'DIAGNOSIS_ENDED_TRANSFER_CHANNEL',
    DIAGNOSIS_ENDED_SHIPMENT_PENDING = 'DIAGNOSIS_ENDED_SHIPMENT_PENDING',
    DIAGNOSIS_ENDED_VALIDATION_PENDING = 'DIAGNOSIS_ENDED_VALIDATION_PENDING',
    DIAGNOSIS_ENDED_CONTINUE_WITHOUT_INTERACTION = 'DIAGNOSIS_ENDED_CONTINUE_WITHOUT_INTERACTION',
    DIAGNOSIS_ENDED_TECHNICIAN_ASSIGNMENT_PENDING = 'DIAGNOSIS_ENDED_TECHNICIAN_ASSIGNMENT_PENDING',
}

export enum EProblemErrorMessage {
    DIAGNOSIS_ENDED_CANCELED = 'Ha transcurrido el tiempo máximo de espera. Si tu problema persiste, abre una nueva incidencia.',
    ERROR_MASIVE = 'El producto presenta afectación de servicio, inténtalo de nuevo más tarde.',
    ERROR_EXIST_ISSUE = 'Ya existe un problema abierto para esa tipología o el problema no esta en el estado correcto.',
    ERROR_CONNECTION = 'En este momento navegas más lento porque has agotado los datos incluidos en tu tarifa. Si quieres volver a nevagar a máxima velocidad, puedes comprar un bono extra de datos.',
}

export enum EProblemFeedbackType {
    SUCCESS = 'success',
    INFO = 'info',
    ERROR = 'error',
}

export enum EProblemFeedback {
    PENDING = 'pending',
    SERVICE = 'service',
    SUCCESS = 'success',
    INCIDENCE = 'incidence',
    DIAGNOSIS = 'diagnosis',
    EXIST_ISSUE = 'exist_issue',
    ERROR_MASIVE = 'error_masive',
    ERROR_CONNECTION = 'error_connection',
    SHIPMENT_PENDING = 'shipment_pending',
    REVISION_TECHNICAL = 'revision_technical',
    REVISION_NOT_CONFORMITY = 'revision_not_conformity',
    TECHNICIAN_ASSIGNMENT_PENDING = 'technician_assignment_pending',
}

export enum EProblemFeedbackMessages {
    SERVICE = 'service',
    INCIDENCE = 'incidence',
}

export enum EProblemFeedbackPhase {
    EXT = 'EXT',
    CUR = 'CUR',
    CER = 'CER',
    REV = 'REV',
    ABI = 'ABI',
    REV_TECH = 'REV_TECH',
    SHIPMENT_PENDING = 'SHIPMENT_PENDING',
    LOGISTIC_SHIPPING = 'LOGISTIC_SHIPPING',
    TECHNICIAN_ASSIGNMENT_PENDING = 'TECHNICIAN_ASSIGNMENT_PENDING',
}

export type ILiteralFeedback = {
    state: string;
    title: string;
    subtitle: string;
};

export type IStepperTimeLineIssue = {
    title: string;
    date: string;
    descriptionType: string;
    customerComments: string;
};

type ICommonDescription = {
    type: string;
    description: string;
};

type IAppointmentProperties = {
    id: string;
    code: string;
    state: string;
    startInterval: string;
    endInterval: string;
};

export type IShippingOrder = {
    id: ICommonDescription;
    startDate: ICommonDescription;
    endDate: ICommonDescription;
    comments: ICommonDescription;
    category: ICommonDescription;
    idCustomer: ICommonDescription;
    alias: ICommonDescription;
    statusSHOs: ICommonDescription;
    incidents: ICommonDescription;
    items: ICommonDescription;
    contactMedia: ICommonDescription;
    location: ICommonDescription;
    reasonCancelRequest: ICommonDescription;
};

export interface IWorkOrder {
    id: ICommonDescription;
    code: ICommonDescription;
    creationDate: ICommonDescription;
    endDate: ICommonDescription;
    idWO: ICommonDescription;
    codeWO: ICommonDescription;
    estimatedDuration: ICommonDescription;
    place: ICommonDescription;
    incident: ICommonDescription;
    appointments: IAppointmentProperties[];
    contacts: ICommonDescription;
    status: ICommonDescription;
    statusName: ICommonDescription;
    statusWO: ICommonDescription;
    statusNameWO: ICommonDescription;
}

export interface IShippingOrderZeleris {
    id: string;
    reference: string;
    date: string;
    situation: string;
    situationDate: string;
    url: string;
    events: IShippingOrderZelerisEvent[];
}

export interface IShippingOrderZelerisEvent {
    date: string;
    time: string;
    description: string;
}
